import { render, staticRenderFns } from "./icorObjectEditForm.vue?vue&type=template&id=00ba226a&scoped=true&"
import script from "./icorObjectEditForm.vue?vue&type=script&lang=js&"
export * from "./icorObjectEditForm.vue?vue&type=script&lang=js&"
import style0 from "./icorObjectEditForm.vue?vue&type=style&index=0&id=00ba226a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ba226a",
  null
  
)

component.options.__file = "icorObjectEditForm.vue"
export default component.exports